import { useState } from "react";

import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, Drawer, Tag } from "@impero-com/ui";
import { Input } from "antd";

import * as theme from "./TagsCell.css";

interface TagsDrawerProps {
    tags: Array<{ id: string; name: string; categoryName: string }>;
    open: boolean;
    onClose: () => void;
}

export function TagsDrawer({ tags, open, onClose }: TagsDrawerProps) {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const close = () => {
        setSearch("");
        onClose();
    };
    const query = search.trim().toLowerCase();
    const matches = tags.filter((tag) =>
        tag.name.toLowerCase().includes(query)
    );

    return (
        <Drawer
            open={open}
            onOpenChange={(nextOpen) => {
                if (!nextOpen) {
                    close();
                }
            }}
            variant="default"
            closeAriaLabel={t("ControlPrograms_EntitiesDrawer_Close")}
            withHeader={{
                title: t("ControlPrograms_TagsDrawer_Title", {
                    count: tags.length,
                }),
            }}
            withFooter={
                <Button variant="primary" onClick={close}>
                    {t("ControlPrograms_EntitiesDrawer_Close")}
                </Button>
            }
        >
            <Input
                className={theme.search}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder={t("ControlPrograms_TagsDrawer_SearchPlaceholder")}
                aria-label={t("ControlPrograms_TagsDrawer_SearchPlaceholder")}
                prefix={<SearchOutlined />}
                suffix={
                    <span>
                        {matches.length}/{tags.length}
                    </span>
                }
                allowClear
                autoFocus
            />
            {matches.length === 0 ? (
                t("ControlPrograms_TagsDrawer_NoMatches")
            ) : (
                <ul className={theme.list}>
                    {matches.map((tag) => (
                        <li key={tag.id}>
                            <Tag wrap>
                                <strong>{tag.categoryName}:</strong> {tag.name}
                            </Tag>
                        </li>
                    ))}
                </ul>
            )}
        </Drawer>
    );
}
